import { Wechat } from '@/api'

const appId = process.env.VUE_APP_WX_APP_ID

const createNonceStr = () =>
  Math.random()
    .toString(36)
    .substring(2, 15)

const createTimestamp = () => parseInt(new Date().getTime() / 1000) + ''

const params = url => ({
  noncestr: createNonceStr(),
  timestamp: createTimestamp(),
  url: url
})

const settings = {
  apiMap: {
    shareOnChat: 'updateAppMessageShareData',
    shareOnMoments: 'updateTimelineShareData',
    showMenuItems: 'showMenuItems',
    hideMenuItems: 'hideMenuItems'
  },
  menuMap: {
    prefix: '',
    // 基本类
    basic: {
      exposeArticle: 'menuItem:exposeArticle',
      setFont: 'menuItem:setFont',
      dayMode: 'menuItem:dayMode',
      nightMode: 'menuItem:nightMode',
      refresh: 'menuItem:refresh'
    },
    // 传播类
    share: {
      Friend: 'menuItem:share:appMessage',
      TimeLine: 'menuItem:share:timeline',
      QQ: 'menuItem:share:qq',
      Weibo: 'menuItem:share:weiboApp',
      FB: 'menuItem:share:facebook',
      QZone: 'menuItem:share:QZone',
      Email: 'menuItem:share:email'
    }
  },
  openMap: {
    app: 'wx-open-launch-app',
    weapp: 'wx-open-launch-weapp'
  }
}
const getBasisConfigs = (link) => {
  const data = params(link)
  return Wechat.signature(data).then(({ signature }) => {
    return {
      // debug: process.env.NODE_ENV !== 'production', // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      // debug: true,
      appId: appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.noncestr, // 必填，生成签名的随机串
      signature // 必填，签名，见附录1
    }
  })
}

export {
  getBasisConfigs,
  settings
}
